"use client";

import AuthWrapper from "@stadium/hooks/lib/use-auth-wrapper";
import usePathMatcher from "@stadium/hooks/lib/use-path-matcher";

import { DISALLOW_SSR_PATHS } from "@constants/config";

const AuthWrapperClient = ({ children }) => {
  const isSSRDisabled = usePathMatcher(DISALLOW_SSR_PATHS);

  return <AuthWrapper staticPage={!isSSRDisabled}>{children}</AuthWrapper>;
};

export default AuthWrapperClient;
